(function () {
  // Guard: snippets/localization-selector.liquid renders in both header and footer,
  // each pulling in this script tag. Prevent double registration of document-level
  // listeners / duplicate customElements.define calls if that happens.
  if (window.__tsbCurrencyConverterLoaded) return;
  window.__tsbCurrencyConverterLoaded = true;

  function convertAmount(rawCents, rates, localCode, targetCode) {
    var localRate = rates[localCode];
    var targetRate = rates[targetCode];

    if (!localRate || !targetRate) return null;

    var amountLocal = rawCents / 100;
    var amountUsd = amountLocal / localRate;
    return amountUsd * targetRate;
  }

  function formatConvertedPrice(rawCents, rates, localCode, targetCode, isFromPrice) {
    var amount = convertAmount(rawCents, rates, localCode, targetCode);
    if (amount === null) return null;

    var formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: targetCode,
    }).format(amount);

    return isFromPrice ? 'From ' + formatted : formatted;
  }

  function applyCurrencyToPrices(code, rates, localCurrency) {
    var containers = document.querySelectorAll('[data-price-convert]');

    containers.forEach(function (container) {
      var textEl = container.querySelector('[data-price-text]');
      if (!textEl) return;

      if (!textEl.dataset.priceOriginal) {
        textEl.dataset.priceOriginal = textEl.textContent.trim();
      }

      var rawCents = parseInt(container.dataset.priceRaw, 10);
      var isFromPrice = container.dataset.priceFormat === 'from';

      if (code === 'local' || isNaN(rawCents) || !rates[code]) {
        textEl.textContent = textEl.dataset.priceOriginal;
        return;
      }

      var converted = formatConvertedPrice(rawCents, rates, localCurrency, code, isFromPrice);
      textEl.textContent = converted !== null ? converted : textEl.dataset.priceOriginal;
    });
  }

  // Tracks the currently selected currency so late-arriving DOM content
  // (see MutationObserver below) knows what to convert to, without needing
  // its own separate re-trigger logic.
  var currentState = { code: 'local', rates: {}, localCurrency: null };

  document.addEventListener('tsb:currency-changed', function (event) {
    currentState = event.detail;
    applyCurrencyToPrices(event.detail.code, event.detail.rates, event.detail.localCurrency);
  });

  // FIX (24 Jul 2026): some price content loads AFTER the initial page load
  // and after any currency-change event has already fired -- e.g. Shopify's
  // native product recommendations ("Pairs well with"), which fetch and
  // inject their markup asynchronously via <product-recommendations>. The
  // sweep above only runs reactively when the currency changes, so anything
  // injected into the DOM afterward was never being converted. This observer
  // watches for newly-added [data-price-convert] elements anywhere on the
  // page and applies whatever currency is currently selected to them too --
  // covers recommendations now, and any other async-loaded price section
  // (upsells, etc.) automatically in future, without needing a bespoke fix
  // each time.
  var priceObserver = new MutationObserver(function (mutations) {
    if (currentState.code === 'local' || !currentState.localCurrency) return;

    var hasNewPriceEls = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-price-convert]')) hasNewPriceEls = true;
        if (node.querySelector && node.querySelector('[data-price-convert]')) hasNewPriceEls = true;
      });
    });

    if (hasNewPriceEls) {
      applyCurrencyToPrices(currentState.code, currentState.rates, currentState.localCurrency);
    }
  });

  priceObserver.observe(document.body, { childList: true, subtree: true });

  class CurrencyDisplaySelector extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.localCurrency = this.dataset.localCurrency;
      this.localSymbol = this.dataset.localSymbol || '';

      try {
        this.rates = JSON.parse(this.dataset.rates || '{}');
      } catch (e) {
        this.rates = {};
      }

      this.toggleLabel = this.querySelector('[data-currency-toggle-label] span');
      this.options = this.querySelectorAll('[data-currency-option]');

      this.options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.select(btn.dataset.currencyOption);
        });
      });

      document.addEventListener('tsb:currency-changed', function (event) {
        self.syncDisplay(event.detail.code);
      });

      // FIX (24 Jul 2026): storage key is now scoped per local currency, e.g.
      // "tsb_display_currency:MYR" vs "tsb_display_currency:SGD" vs
      // "tsb_display_currency:SAR" -- instead of one shared
      // "tsb_display_currency" key across the whole domain.
      //
      // Why: localStorage is scoped to the domain, not the market. Previously,
      // a visitor (or anyone testing) who picked a display currency while on
      // one market, then later landed on a DIFFERENT market in the same
      // browser, would see that old choice incorrectly carried over -- e.g.
      // picking MYR while testing Malaysia, then previewing Singapore, and
      // seeing "MYR" still selected instead of defaulting to SGD. Scoping the
      // key by local currency means each market keeps its own independent
      // memory, and switching markets always starts from that market's own
      // correct default.
      this.storageKey = 'tsb_display_currency:' + this.localCurrency;

      var stored = window.localStorage.getItem(this.storageKey) || 'local';
      this.select(stored, { skipStore: true });
    }

    select(code, opts) {
      opts = opts || {};
      var effectiveCode = this.rates[code] ? code : 'local';

      if (!opts.skipStore) {
        window.localStorage.setItem(this.storageKey, effectiveCode);
      }

      document.dispatchEvent(
        new CustomEvent('tsb:currency-changed', {
          detail: { code: effectiveCode, rates: this.rates, localCurrency: this.localCurrency },
        })
      );
    }

    syncDisplay(code) {
      this.options.forEach((btn) => {
        btn.setAttribute('aria-selected', btn.dataset.currencyOption === code ? 'true' : 'false');
      });

      if (this.toggleLabel) {
        this.toggleLabel.textContent =
          code === 'local' ? (this.localCurrency + ' ' + this.localSymbol).trim() : code;
      }
    }
  }

  if (!customElements.get('currency-display-selector')) {
    customElements.define('currency-display-selector', CurrencyDisplaySelector);
  }
})();